export default __webpack_public_path__ + "static/media/IconSoundSide.86ae4f21.svg";